import { useTranslation } from 'react-i18next'
import { IconLock } from '../verify-report/VerifyReportIcons'

export default function VerifySecureFooter() {
  const { t } = useTranslation()
  return (
    <footer className="verify-loading-footer">
      <IconLock className="verify-loading-footer__icon" />
      <div className="verify-loading-footer__copy">
        <strong>{t('vc.imeiHub.security')}</strong>
        <p>{t('vc.imeiHub.privacy')}</p>
      </div>
    </footer>
  )
}
